/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import MeshBeamMaterial from './materials/MeshBeamMaterial'
import { Vector2 } from 'three'

export default function BeamOuter(props) 
{

    const self = useRef()

    const { nodes } = useGLTF('./models/beam.glb')

    return (
        <group {...props} dispose={null} ref={ self }>
        <mesh
            geometry={nodes.Beam.geometry}
            position={[0, 1.015, 1.023]}
            rotation={[Math.PI / 2, 0, 0]}
        >
            <MeshBeamMaterial
                speedBeam={ new Vector2( 0.0, 0.6 ) }
                skewAmt={ new Vector2( 0.7, 1.1) }
                hardEdge={ true }
            />
        </mesh>
        </group>
    )

}

useGLTF.preload('./models/beam.glb')
